import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { takeReturnTo } from '../utils/returnTo';

export default function PostLoginReturnTo() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading || !user) return;
    const pending = takeReturnTo();
    if (!pending) return;
    const current = `${location.pathname}${location.search}`;
    if (current === pending) return;
    navigate(pending, { replace: true });
  }, [user, loading, location.pathname, location.search, navigate]);

  return null;
}
